import { API, graphqlOperation } from 'aws-amplify'
import {
  listParcoUsers,
  getParcoUser,
  listParcoUsersAlt,
} from 'graphql/custom/queries'
import { getUserDocuments } from 'graphql/custom/queries'
import { apiClient } from 'utils/api/apiClient'

// export const listUsers = async () => {
//   let nextToken = null
//   let allUsers = []

//   do {
//     const response = await API.graphql(
//       graphqlOperation(listParcoUsersAlt, { limit: 2000, nextToken })
//     )
//     const data = response?.data?.listParcoUsers

//     if (data?.items) {
//       allUsers = [...allUsers, ...data.items]
//     }

//     nextToken = data?.nextToken
//   } while (nextToken)

//   return allUsers
//   // Old way that limited results
//   // await API.graphql(graphqlOperation(listParcoUsersAlt, { limit: 2000 }))
// }

// export const getUser = async (id) =>
//   await API.graphql(graphqlOperation(getParcoUser, { id }))

// export const getDocuments = async ({ userId }) => {
//   const { data } = await API.graphql(
//     graphqlOperation(getUserDocuments, { id: userId })
//   )
//   return data?.getParcoUser?.documents?.items || []
// }

export const listUsers = async () => {
  let users = []
  try {
    const { data } = await apiClient.get('api/users')
    users = data.users
  } catch (e) {
    console.error(e)
  }

  return users
}

export const getUser = async (id) => {
  try {
    if (!id || id === 'undefined') {
      console.error('getUser called with invalid id:', id)
      return null
    }
    const { data } = await apiClient.get(`api/users/${id}`)
    return data.user
  } catch (e) {
    console.error(e)
    return {}
  }
}

export const getUserByEmail = async (id) => {
  try {
    const { data } = await apiClient.get(`api/users/${id}`)
    return data.user
  } catch (e) {
    console.error(e)
    return {}
  }
}

const submittableValues = (values = {}) => {
  const {
    assets: _assets,
    liabilities: _liabilities,
    deductions: _deductions,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    recommendations: _recommendations,
    deductionTypesToInput: _deductionTypesToInput,
    selectedDeductions: _selectedDeductions,
    tspLoanToSubmit: _tspLoanToSubmit,
    plaidAccessTokens: _plaidAccessTokens,
    tasks: _tasks,
    id: _id,
    ...submittableValues
  } = values

  return submittableValues
}

export const updateUser = async (id, updatedUserAttributes = {}) => {
  const valuesToupdate = submittableValues(updatedUserAttributes)
  try {
    const { data } = await apiClient.put(`api/users/${id}`, {
      user: valuesToupdate,
    })
    return data.user
  } catch (e) {
    console.error(e)
    return {}
  }
}

export const updateQuiltt = async (quilttUserId) => {
  try {
    const { data } = await apiClient.put(`api/quiltt/quilttSession`, {
      quilttUserId: quilttUserId,
    })
    console.log(data)
  } catch (e) {
    console.error(e)
  }
}
